import React, {Component} from "react";
import {Growl} from 'primereact/growl';
import AladdinReportView from "./AladdinReportView";
import {ReportsService} from "../../service/reports/ReportsService";
import ConfirmationMessage from "../../components/confirmationMessage";
import {AladdinService} from "../../service/aladdin/AladdinService";
import dateFormat from "dateformat";

export default class AladdinReportContainer extends Component {
    constructor(props) {
        super(props);
        this.reportsService = new ReportsService();
        this.aladdinService = new AladdinService();
        this.exportDocument = this.exportDocument.bind(this);
        this.confirmationRef = null;
        this.today = new Date();
        this.setConfirmationRef = element => {
            this.confirmationRef = element
        };

        this.state = {
            isLoading: true,
            optionsFilter: {
                inicioPrestamos: "inicioPrestamos",
                garantiasES: "garantiasES",
                restricciones: "restricciones"
            },
            filters: {
                valueAladdinReport: "",
                udiValue: "",
                today: this.today,
                udiDate: this.today
            },
            exportOptions: [
                {
                    label: "CSV", action: () => {
                        this.openConfirmationMessage("CSV")
                    }
                },
            ],
            typeDocument: '',
        };
        this.onChangeFilters = this.onChangeFilters.bind(this);
        this.clearFilters = this.clearFilters.bind(this);
        this.openConfirmationMessage = this.openConfirmationMessage.bind(this);
        this.loading = this.loading.bind(this);
        this.validUDIvalue = this.validUDIvalue.bind(this);
        this.validUDIDate = this.validUDIDate.bind(this);
        this.saveUdiValue = this.saveUdiValue.bind(this);
        this.getTodayUdiValue = this.getTodayUdiValue.bind(this);
        this.exportUdiValues = this.exportUdiValues.bind(this);
    }

    onChangeFilters(event) {
        let filtersAux = this.state.filters;
        filtersAux[event.target.name] = event.target.value;
        this.setState({
            filters: filtersAux,
        });
    }
    clearFilters() {
        this.setState({
            filters: {
                valueAladdinReport: "",
            },
        });
        this.getTodayUdiValue();
    }

    componentDidMount() {
        let message = this.props.location.message ? this.props.location.message : null;
        if (message !== null && message.severity) {
            this.growl.show({
                severity: message.severity ? message.severity : '',
                summary: message.summary ? message.summary : '',
                detail: message.detail ? message.detail : '', message
            });
        }
        this.getTodayUdiValue();
    }

    loading(option) {
        if (this.state !== undefined) {
            this.setState({
                isLoading: option ? option : false,
            });
        }
    }

    openConfirmationMessage(docType) {
        if (this.confirmationRef) {
            this.setState({
                typeDocument: docType
            });
            this.confirmationRef.openConfirmationMessage();
        }
    }

    validUDIvalue(){
        let isValid = true;
        let udiValue = this.state.filters.udiValue;
        if((udiValue === undefined)||(udiValue === "")) {
            isValid = false;
            this.growl.show({
                severity: 'error', summary: 'Info.',
                detail: 'Falta capturar el valor UDI'
            });
        } else if (udiValue < 1 || udiValue >= 100){
            isValid = false;
            this.growl.show({
                severity: 'error', summary: 'Info.',
                detail: 'El valor UDI debe estar entre 1 y 99.999999.'
            });
        }
        return isValid;
    }

    validUDIDate(){
        let isValid = true;
        let udiDate = this.state.filters.udiDate;
        if(udiDate === undefined) {
            isValid = false;
            this.growl.show({
                severity: 'error', summary: 'Info.',
                detail: 'Falta capturar el valor Fecha para UDI'
            });
        }
        return isValid;
    }

    exportDocument() {
        let report = this.state.filters.valueAladdinReport;
        if(report === undefined || report === "" ){
            this.growl.show({
                severity: 'error', summary: 'Atención.',
                detail: 'Seleccionar un valor para el reporte.'
            });
        } else {
            this.loading(true);
            switch (this.state.typeDocument) {
                case "CSV":
                    this.reportsService.getAladdinReportCSV(this.state.filters)
                        .then(res => {
                            if (res.message === 'Success') {
                                this.growl.show({severity: 'success', summary: 'Éxito.',
                                    detail: 'Se envió correo exitosamente.'});

                            } else if (res.error !== '') {
                                this.growl.show({severity: 'error', summary: 'Error al enviar.', detail: res.error});
                            }
                            this.loading(false);
                        });
                    break;
                default:
                    break;
            }
        }
    }

    saveUdiValue() {
        let isValidUdi = this.validUDIvalue();
        let isValidDate = this.validUDIDate();

        if(isValidUdi && isValidDate) {
            let udiValue = this.state.filters.udiValue;
            let udiDate = dateFormat(this.state.filters.udiDate.toDateString(), "dd-mm-yyyy");
            this.loading(true);
            this.aladdinService.saveUdiValue(udiValue, udiDate).then(res => {
                if (res.message === 'Success') {
                    this.growl.show({severity: 'success', summary: 'Éxito.',
                        detail: 'Valor guardado exitosamente.'});

                } else if (res.error !== '') {
                    this.growl.show({severity: 'error', summary: 'Error al guardar.', detail: res.error});
                }
                this.loading(false);
            });
        }
    }

    getTodayUdiValue(){
        this.loading(true);
        this.aladdinService.getTodayUdiValue().then(res => {
            if (res.message === 'Success') {
                let udiData = res.payload[0];
                let udiDateParts = udiData.udiDate.split('-');
                let udiDate = new Date(udiDateParts[0], udiDateParts[1] - 1, udiDateParts[2]);
                let filtersAux = this.state.filters;
                filtersAux["udiValue"] = udiData.value;
                filtersAux["udiDate"] = udiDate;

                this.setState({
                    filters: filtersAux,
                });

            } else if (res.error !== '') {
                this.growl.show({severity: 'error', summary: 'Error.', detail: res.error});
                this.setState({
                    filters: {
                        udiValue: "",
                        udiDate: this.today
                    },
                });
            }
            this.loading(false);
        });
    }

    exportUdiValues(){
        this.loading(true);
        this.aladdinService.getUdiValuesCSV().then(resp =>{
            this.loading(false);
        });
    }

    render() {
        let confMsg = <ConfirmationMessage ref={this.setConfirmationRef}
                                           invisible={true}
                                           legend="¿Está seguro de enviar el correo con el reporte?"
                                           action={this.exportDocument}/>;
        let messagesGrowl = <Growl ref={(el) => this.growl = el}/>;

        return <AladdinReportView
            optionsFilter={this.state.optionsFilter}
            isLoading={this.state.isLoading}
            filters={this.state.filters}
            exportOptions={this.state.exportOptions}
            onChangeFilters={this.onChangeFilters}
            clearFilters={this.clearFilters}
            saveUdiValue={this.saveUdiValue}
            exportUdiValues={this.exportUdiValues}
            messagesGrowl={messagesGrowl}
            confMsg={confMsg}
        />
    }
};